import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';

import { LocationField } from '../../../app/spaces/Tooltips/Elements/LocationField';
import { Name } from '../../../app/spaces/Tooltips/Elements/Name';
import { Timestamp } from '../../../app/spaces/Tooltips/Elements/Timestamp';
import { Tooltip } from '../../../app/spaces/Tooltips/Elements/Tooltip';
import { User } from '../../../app/spaces/Tooltips/Elements/User';
import { ContentTooltipProps, getPersonalSpaceLink,getProjectLink, TooltipDescriptionTestId } from '../../../app/spaces/Tooltips/TooltipHelper';
import { Messages } from '../../../codegen/Localize';
import { IDataRoleInfo } from '../../models/IDataRoleInfo';

export function DataRoleTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const projectLink = getProjectLink((props.content as IDataRoleInfo).project, urls);
  const personalSpaceLink = getPersonalSpaceLink(urls);
  const locationType = (props.content as IDataRoleInfo).location?.type;
  const ownerId = content.owner?.id;

  return (
    <Tooltip>
      <Name name={content.name} />
      <MarkupField markup={props.content.description}
                  testId={TooltipDescriptionTestId}
                  extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <LocationField inProjectSpace={props.inProjectSpace} inPersonalSpace={props.inPersonalSpace} locationType={locationType}
        projectLink={projectLink} personalSpaceLink={personalSpaceLink} contentOwnerId={ownerId}/>
      <User user={props.content.owner} label={Messages.owner()} urls={urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
